namespace $ {

	export function $shm_projects_task_update( project_id: string, id: string, change: Partial< $shm_projects_task_record > ) {
		const tasks = [ ... $shm_projects_tasks_list( project_id ) ]
		const index = tasks.findIndex( task => task.id === id )
		if( index < 0 ) throw new Error( `Unknown task: ${ id }` )
		const next = { ... tasks[ index ], ... change, id, project_id, updated_at: Date.now() }
		tasks[ index ] = next
		$mol_state_local.value( `$shm_projects_tasks(${ project_id })`, tasks )
		return next
	}

}
